export default __webpack_public_path__ + "8a41ca4f62b766646ed67752baecc217.png";